/* ==========================================================================
   Bazan 2026 — generic scroll-snap slider. Shared by bz-hero, bz-product-slider,
   bz-steps. Hooks:
     [data-bz-slider]            root (opts: data-autoplay="true", data-interval="6")
       [data-bz-track]           horizontal scroll container
         [data-bz-slide]         each slide (one or more visible via CSS)
       [data-bz-dots]            dots wrapper (auto-hidden when not scrollable)
         [data-bz-dot="i"]       dot -> go to slide i
       [data-bz-prev] / [data-bz-next]   optional arrows (step by one slide)
   ========================================================================== */
(function () {
  'use strict';

  function initPaged(root, track, dotsWrap, prev, next) {
    function pageW() { return track.clientWidth || 1; }
    function pageCount() { 
      var w = pageW();
      if (w < 2) return 1;
      var slides = track.querySelectorAll('[data-bz-slide]');
      var scrollPages = Math.ceil((track.scrollWidth - 2) / w - 0.001);
      return Math.max(1, Math.min(slides.length, scrollPages)); 
    }
    function curPage() { return Math.round(track.scrollLeft / pageW()); }

    function buildDots() {
      if (!dotsWrap) return;
      var n = pageCount();
      dotsWrap.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bz-dot' + (i === curPage() ? ' is-active' : '');
        b.setAttribute('data-bz-dot', i);
        b.setAttribute('aria-label', 'Go to page ' + (i + 1));
        (function (idx) { b.addEventListener('click', function () { goToPage(idx); }); })(i);
        dotsWrap.appendChild(b);
      }
      dotsWrap.style.display = n > 1 ? '' : 'none';
    }
    function setActive() {
      if (!dotsWrap) return;
      var cur = curPage();
      Array.prototype.forEach.call(dotsWrap.children, function (d, i) { d.classList.toggle('is-active', i === cur); });
    }
    function goToPage(p) {
      var n = pageCount();
      var idx = Math.max(0, Math.min(n - 1, p));
      track.scrollTo({ left: idx * pageW(), behavior: 'smooth' });
    }
    function syncControls() {
      var scrollable = pageCount() > 1;
      [prev, next].forEach(function (el) { if (el) el.style.display = scrollable ? '' : 'none'; });
    }

    function syncHeight() {
      var viewport = track.parentElement;
      if (!viewport) return;
      var w = pageW();
      var scrollLeft = track.scrollLeft;
      var slides = track.querySelectorAll('[data-bz-slide]');
      var maxH = 0;
      Array.prototype.forEach.call(slides, function (slide) {
        var left = slide.offsetLeft - scrollLeft;
        if (left < w - 1 && (left + slide.offsetWidth) > 1) {
          maxH = Math.max(maxH, slide.offsetHeight);
        }
      });
      if (maxH > 0) viewport.style.height = maxH + 'px';
    }

    if (prev) prev.addEventListener('click', function () { goToPage(curPage() - 1); });
    if (next) next.addEventListener('click', function () { goToPage(curPage() + 1); });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { setActive(); syncHeight(); }, 80);
    }, { passive: true });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { buildDots(); syncControls(); syncHeight(); }, 120);
    });

    buildDots();
    syncControls();
    syncHeight();
  }


  function initSlider(root) {
    if (root.__bzSlider) return;
    root.__bzSlider = true;

    var track = root.querySelector('[data-bz-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-bz-slide]'));
    if (slides.length < 1) return;
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-bz-dot]'));
    var dotsWrap = root.querySelector('[data-bz-dots]');
    var prev = root.querySelector('[data-bz-prev]');
    var next = root.querySelector('[data-bz-next]');

    // Paged mode: dots = number of pages (page width = viewport width).
    if (root.hasAttribute('data-bz-paged')) { initPaged(root, track, dotsWrap, prev, next); return; }

    function maxScrollable() {
      return (track.scrollWidth - track.clientWidth) > 2;
    }
    function syncControls() {
      var scrollable = maxScrollable();
      if (dotsWrap) dotsWrap.style.display = scrollable ? '' : 'none';
      [prev, next].forEach(function (el) { if (el) el.style.display = scrollable ? '' : 'none'; });
    }
    function leftIndex() {
      var pos = track.scrollLeft, best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs((s.offsetLeft - track.offsetLeft) - pos);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    function setActive(i) {
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
    }
    function goTo(i) {
      var idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(idx);
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-bz-dot'), 10)); stop(); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(leftIndex() - 1); stop(); });
    if (next) next.addEventListener('click', function () { goTo(leftIndex() + 1); stop(); });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { setActive(leftIndex()); }, 80);
    }, { passive: true });

    window.addEventListener('resize', syncControls);

    // autoplay
    var timer = null;
    var autoplay = root.getAttribute('data-autoplay') === 'true' && slides.length > 1;
    var interval = (parseFloat(root.getAttribute('data-interval')) || 6) * 1000;
    function tick() {
      var i = leftIndex();
      goTo(i >= slides.length - 1 ? 0 : i + 1);
    }
    function start() { if (autoplay && !timer) timer = setInterval(tick, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    setActive(0);
    syncControls();
    start();
  }

  function boot() { document.querySelectorAll('[data-bz-slider]').forEach(initSlider); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('[data-bz-slider]').forEach(initSlider);
  });
})();
